import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const BackBurger: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4.99993 13L8.99993 17L7.59993 18.42L1.17993 12L7.59993 5.57996L8.99993 6.99996L4.99993 11H20.9999V13H4.99993ZM20.9999 5.99996V7.99996H10.9999V5.99996H20.9999ZM20.9999 16V18H10.9999V16H20.9999Z" />
  </SvgIcon>
);
